















/**
 * 榜单模块
 */
import {Vue, Component} from 'vue-property-decorator';
import RankList from '@/components/RankList/index.vue';
import UTitle from '@/components/UTitle/index.vue';

function getTopTypes(): string[] {
  const types: string[] = Array.from({length: 24}).map((_, i) => `${i}`);
  const l = types.length;
  const rds: number[] = [];
  while (true) {
      const rd1 = Math.floor(Math.random() * l);
      if (!rds.includes(rd1)) {
        rds.push(rd1);
      }
      if (rds.length === 3) {
        break;
      }
    }
  return rds.map((i) => types[i]);
}

/**
 * 每次页面只变换一次
 */
const resultTypes = getTopTypes();

@Component({
  components: {
    RankList,
    UTitle,
  },
})
export default class RankListPanel extends Vue {
  public resultTypes = resultTypes;
}
